import { render } from "./BaseAvatar.vue?vue&type=template&id=71d66692&scoped=true"
import script from "./BaseAvatar.vue?vue&type=script&lang=js"
export * from "./BaseAvatar.vue?vue&type=script&lang=js"

import "./BaseAvatar.vue?vue&type=style&index=0&id=71d66692&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d66692"]])

export default __exports__